var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgIconAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#CEDCFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76 28H44C41.8783 28 39.8434 28.8429 38.3431 30.3431C36.8429 31.8434 36 33.8783 36 36V84C36 86.1217 36.8429 88.1566 38.3431 89.6569C39.8434 91.1571 41.8783 92 44 92H76C78.1217 92 80.1566 91.1571 81.6569 89.6569C83.1571 88.1566 84 86.1217 84 84V36C84 33.8783 83.1571 31.8434 81.6569 30.3431C80.1566 28.8429 78.1217 28 76 28ZM62 52V58H68C68.5304 58 69.0391 58.2107 69.4142 58.5858C69.7893 58.9609 70 59.4696 70 60C70 60.5304 69.7893 61.0391 69.4142 61.4142C69.0391 61.7893 68.5304 62 68 62H62V68C62 68.5304 61.7893 69.0391 61.4142 69.4142C61.0391 69.7893 60.5304 70 60 70C59.4696 70 58.9609 69.7893 58.5858 69.4142C58.2107 69.0391 58 68.5304 58 68V62H52C51.4696 62 50.9609 61.7893 50.5858 61.4142C50.2107 61.0391 50 60.5304 50 60C50 59.4696 50.2107 58.9609 50.5858 58.5858C50.9609 58.2107 51.4696 58 52 58H58V52C58 51.4696 58.2107 50.9609 58.5858 50.5858C58.9609 50.2107 59.4696 50 60 50C60.5304 50 61.0391 50.2107 61.4142 50.5858C61.7893 50.9609 62 51.4696 62 52Z",
    fill: "#4974D1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_906"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(28 28)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIconAdd);
export default __webpack_public_path__ + "static/media/img-icon-add.7a2080e4376e73fb8fc3a17289e97e31.svg";
export { ForwardRef as ReactComponent };